
import template from '../../../templates/checkout-flow/billing.directive.tpl.html';

import app from '../../App';

export function billingDirective (PayByCheckService,Info,SignUpPaidService,ShippingRatesService,CurrencyHelper) {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '=',
            selectedshippingrate: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs ) => {
            scope.Info=Info;
            scope.CurrencyHelper=CurrencyHelper;
            scope.billing={};
            scope.billing.payBy='CC';
            scope.payByCheck={};
            scope.payByCheckSended=false;
            scope.shippingRates=[];
            scope.accountDelivery='';
            scope.loading=true;
            scope.ccErrorShow=false;
            scope.ccError='';
            scope.$watch('accountDelivery',(newValue) =>{
                if(scope.shippingRates.length>0) {
                    scope.selectedshippingrate = scope.shippingRates.slice(0).filter((value) => value.RateId == newValue).shift();
                }
            },true);
            scope.$watch('data.billingInfo',() => {
                scope.submitBillingInfo();
            },true);
            scope.$watch('data.billingAddressInfo',() => {
                scope.submitBillingInfo();
            },true);
            scope.$watch('data.billingAddressInfo.country', () => {
                scope.data.billingAddressInfo.state='';
            },true);
            scope.$watch('data.addressID', () => {
                if(scope.data.addressID!='') {
                    ShippingRatesService.getShippingOptions(scope.data.addressID,scope.data.pricingParams.devices).then(
                        (response)=> {
                            console.log(response);
                            if(response.data.Success && response.data.Result instanceof Array){
                                scope.shippingRates=response.data.Result;
                            }else{

                            }
                            scope.loading=false;
                        }
                    );
                }
            });

            scope.submitBillingInfo = () => {
                let billingCurly = {
                    number: scope.data.billingInfo.number,
                    month: scope.data.billingInfo.month,
                    year: scope.data.billingInfo.year,
                    first_name: scope.data.billingInfo.firstName,
                    last_name: scope.data.billingInfo.lastName,
                    cvv: scope.data.billingInfo.ccv,
                    address1: (scope.data.pricingParams.devices==0||scope.data.billingAddressInfo.address!='')?scope.data.billingAddressInfo.address:scope.data.shippingAddressInfo.address,
                    address2: null,
                    city: (scope.data.pricingParams.devices==0||scope.data.billingAddressInfo.city!='')?scope.data.billingAddressInfo.city:scope.data.shippingAddressInfo.city,
                    state: ((scope.data.pricingParams.devices==0||scope.data.billingAddressInfo.state!='')&&(scope.data.billingAddressInfo.country=="US"||scope.data.billingAddressInfo.country=="CA"||scope.data.shippingAddressInfo.country=="US"||scope.data.shippingAddressInfo.country=="CA"))?scope.data.billingAddressInfo.state:scope.data.shippingAddressInfo.state,
                    postal_code: (scope.data.pricingParams.devices==0||scope.data.billingAddressInfo.postalcode!='')?scope.data.billingAddressInfo.postalcode:scope.data.shippingAddressInfo.postalCode,
                    country: (scope.data.pricingParams.devices==0||scope.data.billingAddressInfo.country!='')?scope.data.billingAddressInfo.country:scope.data.shippingAddressInfo.country,
                };
                if(scope.billingForm.$valid) {
                    recurly.token(billingCurly, (err, token) => {
                        if (err) {
                            // handle error using err.code and err.fields
                            scope.ccErrorShow=true;
                            scope.data.token='';
                            scope.ccError=err.message;
                            scope.$apply();
                        }
                        if(token) {
                            // scope.signUpPaidService(token.id);
                            scope.ccErrorShow=false;
                            scope.data.token = token.id;
                            scope.$apply();
                        }
                    });
                }
            };

            scope.payByCheckSubmit = (form) => {
                PayByCheckService.sendPayByCheckForm(scope.payByCheck.name,scope.payByCheck.email,scope.payByCheck.phone,scope.data.plan,scope.data.displays,scope.data.devices).then(
                    (response) => {
                        console.log(response);
                        if(response.status==204){
                            scope.payByCheckSended=true;
                        }else{
                            console.log(response);
                        }
                    },
                    (reject) => {
                        console.log(reject);
                    }
                );
            };

            scope.fillAndSubmit = () => {
                console.log('fillAndSubmit');
                scope.data.billingInfo.number='4111111111111111';
                scope.data.billingInfo.month='2';
                scope.data.billingInfo.year='2017';
                scope.data.billingAddressInfo.firstName=scope.data.billingInfo.firstName='Leo';
                scope.data.billingAddressInfo.lastName=scope.data.billingInfo.lastName='Saturday';
                scope.data.billingInfo.ccv=123;
                scope.data.billingAddressInfo.address='1 Shell Drive';
                scope.data.billingAddressInfo.city='Los Angeles';
                scope.data.billingAddressInfo.state='California';
                scope.data.billingAddressInfo.postalcode='90210';
                scope.data.billingAddressInfo.country='US';
                scope.submitBillingInfo();
            };

            scope.signUpPaidService = () => {
                var deviceInfo = {Price:199.00,ProductTitle:"Enplug Device",Sku:"online"};
                SignUpPaidService.signup(scope.data.accountInfo,scope.data.shippingAddressInfo,scope.data.billingInfo,scope.data.billingAddressInfo,scope.data.pricingParams,deviceInfo).then(
                    (response) => {
                        if(repsonse.data.Success){
                            console.log(result);
                            // scope.data.step=4;
                        }else{

                        }

                    }
                )
            };
        }
    };
};

app.directive( 'billingDirective',billingDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/billing-directive.js